<template>
  <span class="icon"><img :src="iconSrc" alt="" /></span>
</template>

<script>
export default {
  name: 'Icon',
  props: {
    icon: {
      type: String,
      required: true,
    },
  },
  computed: {
    iconSrc() {
      return `${process.env.VUE_APP_BASE_URL}/img/icon-${this.icon}.svg`;
    },
  },
};
</script>
